export const isEnabledEnvValue = (value?: string) => (
    ["1", "true", "yes", "on"].includes(value?.toLowerCase() || "")
)

export const ENABLE_DELIVERY_CENTER = isEnabledEnvValue(process.env.REACT_APP_ENABLE_DELIVERY_CENTER)
export const ENABLE_ADDRESS_CHECK = isEnabledEnvValue(process.env.REACT_APP_ENABLE_ADDRESS_CHECK)
export const ENABLE_TELEGRAM_BROADCASTS = isEnabledEnvValue(process.env.REACT_APP_ENABLE_TELEGRAM_BROADCASTS)
export const ENABLE_NOTIFICATIONS = isEnabledEnvValue(process.env.REACT_APP_ENABLE_NOTIFICATIONS)
export const ENABLE_MARKETING_STORIES = isEnabledEnvValue(process.env.REACT_APP_ENABLE_MARKETING_STORIES)
export const ENABLE_MARKETING_PROMOTIONS = isEnabledEnvValue(process.env.REACT_APP_ENABLE_MARKETING_PROMOTIONS)
export const ENABLE_MARKETING_SEGMENTS = isEnabledEnvValue(process.env.REACT_APP_ENABLE_MARKETING_SEGMENTS)
